import { Controller } from "@hotwired/stimulus"

// Manages dynamic bank account form fields in admin settings
export default class extends Controller {
  static targets = ["container", "noAccountsMessage"]
  static values = { index: Number }

  connect() {
    // Initialize index based on existing accounts
    this.indexValue = this.containerTarget.querySelectorAll('.bank-account-row').length
  }

  add(event) {
    event.preventDefault()
    
    // Remove "no accounts" message if present
    if (this.hasNoAccountsMessageTarget) {
      this.noAccountsMessageTarget.remove()
    }

    const html = this.buildAccountHtml(this.indexValue)
    this.containerTarget.insertAdjacentHTML('beforeend', html)
    this.indexValue++
  }

  remove(event) {
    event.preventDefault()
    const row = event.target.closest('.bank-account-row')
    row.remove()

    // Show message if no accounts left
    if (this.containerTarget.children.length === 0) {
      this.containerTarget.insertAdjacentHTML('afterend', `
        <div class="text-muted text-center py-3" data-bank-accounts-target="noAccountsMessage">
          No bank accounts configured. Click "Add Account" to add one.
        </div>
      `)
    }
  }

  buildAccountHtml(index) {
    return `
      <div class="bank-account-row border rounded p-3 mb-3" data-index="${index}">
        <div class="d-flex justify-content-between align-items-start mb-2">
          <strong>Account ${index + 1}</strong>
          <button type="button" class="btn btn-sm btn-outline-danger" data-action="bank-accounts#remove">Remove</button>
        </div>
        <div class="row">
          <div class="col-md-4 mb-2">
            <label class="form-label small">Bank Name</label>
            <input type="text" name="bank_accounts[${index}][name]" class="form-control" placeholder="e.g. LHV Pank">
          </div>
          <div class="col-md-5 mb-2">
            <label class="form-label small">IBAN</label>
            <input type="text" name="bank_accounts[${index}][iban]" class="form-control" placeholder="EE00 0000 0000 0000 0000">
          </div>
          <div class="col-md-3 mb-2">
            <label class="form-label small">SWIFT/BIC</label>
            <input type="text" name="bank_accounts[${index}][swift]" class="form-control" placeholder="LHVBEE22">
          </div>
        </div>
      </div>
    `
  }
}
